import React, { PureComponent } from 'react';
import {
    LineChart, PieChart, Pie, Sector, Cell, Line, XAxis, YAxis,
    CartesianGrid, Radar, RadarChart, PolarGrid,
    PolarAngleAxis, PolarRadiusAxis, Tooltip,
    Legend, ResponsiveContainer, AreaChart, Area
} from 'recharts';

import Divider from '@material-ui/core/Divider';

import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import NumberFormat from 'react-number-format';

export class CustomerMetrics extends React.Component {
    render() {

        return (
            <div  style={{ marginTop: 50 }}>
                    <Typography variant="h6" id="tableTitle">
                    Compras diarias <Typography variant="subtitle1" id="tableTitle">ultimos 60 dias</Typography>
                    </Typography>
                <ResponsiveContainer width={800} height={300}>
                    <LineChart
                        width={700}
                        height={300}
                        data={this.props.metrics.daily_purchases}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis
                            tickFormatter={tick => {
                                return '$' + tick.toLocaleString();
                            }}
                        />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="Monto" stroke="#ea8b0e" activeDot={{ r: 7 }} />
                    </LineChart>

                </ResponsiveContainer>
                {/* <div className='col-md-5' style={{ marginTop: 40 }}>
                </div>
                <div className='col-md-5 '> */}
                <div className='col-md-10' style={{ marginTop: 40 }}>
                    <Typography variant="h6" id="tableTitle">
                        Productos frecuentes
                    </Typography>
                    <Divider/>
                </div>
                <div className='col-md-10' style={{ marginTop: 40 }}>
                    
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Codigo</TableCell>
                                <TableCell align="center">Tipo</TableCell>
                                <TableCell align="center">Descripcion</TableCell>
                                <TableCell align="center">total de Items</TableCell>
                                <TableCell align="center">Subtotal</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.props.metrics.top_products.map(row => (
                                <TableRow key={row.code}>
                                    <TableCell align="center" component="th" scope="row"> {row.code}  </TableCell>
                                    <TableCell align="center">{row.type}</TableCell>
                                    <TableCell align="center">{row.products}</TableCell>
                                    <TableCell align="center">{row.total_items}</TableCell>
                                    <TableCell align="center"><NumberFormat
                                        value={row.subtotal}
                                        displayType={'text'}
                                        thousandSeparator={'.'}
                                        decimalSeparator={','}
                                        prefix="$"
                                    /></TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
                <div className='col-md-6' style={{ marginTop: 40 }}>
                    <Typography variant="subtitle1" id="tableTitle">
                        <b>Monto promedio por compra: </b>
                        <NumberFormat
                            value={this.props.metrics.amount_purchases.average}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />

                    </Typography>
                    <Typography variant="subtitle1" id="tableTitle">
                        <b>Monto total: </b><NumberFormat
                            value={this.props.metrics.amount_purchases.cumulative}
                            displayType={'text'}
                            thousandSeparator={'.'}
                            decimalSeparator={','}
                            prefix="$"
                        />
                    </Typography>
                </div>
                <div className='col-md-10' style={{ marginTop: 40 }}>
                <Typography variant="h6" id="tableTitle">
                        Distribucion de productos adquiridos (por tipo)
                    </Typography>
                    <Divider/>
                    <div className='col-md-offset-2'>
                    <ResponsiveContainer width={500} height={450}>
                        <RadarChart cx={300} cy={250} outerRadius={150}
                            width={400}
                            height={400}
                            data={this.props.metrics.acquired_products}>
                            <PolarGrid />
                            <PolarAngleAxis dataKey="tipo" />
                            <PolarRadiusAxis />
                            <Radar name="Productos" dataKey="cantidad" stroke="#8884d8" fill="#ea8b0e" fillOpacity={0.6} />
                        </RadarChart>
                    </ResponsiveContainer>
                    </div>
                </div>




            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Customer/Metrics.js